import Component from '../../Component';

export default class CustomSelect extends Component<HTMLElement> {
	// Defines the element selector which will initialize this component
	static selector = '.custom-select';

	// Defines initial State
	state = {
		expanded: false,
	};

	afterInit() {
		this.element.addEventListener('click', this.onClick.bind(this));
	}

	onClick() {
		const { expanded } = this.state;
		this.setState({ expanded: !expanded });
	}

	// Triggers when state is change by calling this.setState()
	componentDidUpdate() {
		const { expanded } = this.state;

		this.element.classList.toggle('custom-select--expanded', expanded);
	}
}

CustomSelect.init();
